const base_url = "https://clinic-system-gamma.vercel.app/api/v1"
export default base_url